import { BaseFinalCommandOptionSchema } from "./BaseFinalCommandOptionSchema";
import { BaseCommand } from "./BaseCommand";

export abstract class BaseFinalCommand extends BaseCommand
{
    protected args: string[];
    protected options: BaseFinalCommandOptionSchema[];
    protected option_values: any = {};
    protected arg_values: any = {};
    constructor(argv: string[], args: string[], options: BaseFinalCommandOptionSchema[])
    {
        super(argv);
        this.args = args;
        this.options = options;
        this.options.push({
            name: "help",
            short: "h",
            args: [],
            defaults: false,
            description: "Prints the instrcution of this command",
            optional: true
        });
    }
    private getOption(name: string): BaseFinalCommandOptionSchema 
    {
        for (let i = 0; i < this.options.length; i++)
        {
            const element = this.options[i];
            if (element.name == name || element.short == name)
                return element;
        }
        throw new Error("Could not find the option: " + name);
    }
    protected override async getError(): Promise<string | null>
    {
        let option_provided: { [name: string]: boolean } = {};
        this.option_values = {};
        this.arg_values = [];
        for (let i = 0; i < this.options.length; i++)
        {
            const option = this.options[i];
            if (option.args.length == 0)
                this.option_values[option.name] = false;
            else if (option.args.length == 1)
                this.option_values[option.name] = option.defaults[0];
            else
                this.option_values[option.name] = option.defaults;
            option_provided[option.name] = false;
        }
        let processOption = (index: number, name: string): number =>
        {
            let option = this.getOption(name);
            if (option.args.length == 0)
                this.option_values[option.name] = true;
            else if (option.args.length == 1)
                this.option_values[option.name] = null;
            else
                this.option_values[option.name] = [];
            option_provided[option.name] = true;
            for (let o = 1; o <= option.args.length; o++)
            {
                if (!this.argv[index + o])
                    throw new Error(`Option '${name}' requires ${option.args.length} arguments.`);
                if (option.args.length == 1)
                    this.option_values[option.name] = this.argv[index + o];
                else
                    this.option_values[option.name].push(this.argv[index + o]);
            }
            return option.args.length;
        };
        let index = 0;
        for (let i = 0; i < this.argv.length; i++)
        {
            let arg = this.argv[i];
            if (arg.startsWith("--"))
            {
                let name = arg.substring(2);
                try
                {
                    i += processOption(i, name);
                } catch (error: any)
                {
                    return error.message;
                }
            }
            else if (arg.startsWith("-"))
            {
                let name = arg.substring(1);
                for (let s = 0; s < name.length; s++)
                {
                    const short = name[s];
                    let option = this.getOption(short);
                    if (name.length > 1 && option.args.length != 0)
                        return "Can not combine option requiring arguments: -" + short;
                    try
                    {
                        i += processOption(i, short);
                    } catch (error: any)
                    {
                        return error.message;
                    }
                }
            }
            else
            {
                if (index >= this.args.length)
                    return "Extra arguments were provided";
                this.arg_values.push(arg);
                index++;
            }
        }
        for (let i = 0; i < this.options.length; i++)
        {
            const option = this.options[i];
            if (!option_provided[option.name])
                if (!option.optional)
                    return `Option ${option.name} is required, but not provied.`;
        }
        if (index != this.args.length)
            return `Less arguemnts are provided. ${this.args.length} is required, but ${index} was provided`;
        return null;
    }
    override isHelp(): boolean
    {
        return this.option_values.help;
    }
    override help(): void
    {
        this.app.logger.info("The command format here is:");
        let command = this.getName();
        for (let i = 0; i < this.args.length; i++)
            command += " " + `{${this.args[i]}}`;
        this.app.logger.info(`    ${command}`);
        for (let i = 0; i < this.options.length; i++)
        {
            let option = this.options[i];
            this.app.logger.info(`        --${option.name} | -${option.short} ${option.optional ? "(optional)" : ""}`.padEnd(40, ' ') + `=> ${option.description}`);
            if (option.args.length > 0)
            {
                this.app.logger.info(`            Arguments:`);
                for (let j = 0; j < option.args.length; j++)
                    this.app.logger.info(`                ${option.args[j]} (default is ${option.defaults[j]})`);
            }
        }
    }
}